import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { TranslateHtml } from '@change-corgi/core-react/i18n';

type Props = {
	/** A take exists, so how to record it is no longer the useful advice. */
	isReviewing: boolean;
};

/**
 * One box, two sets of advice: the recorder screen's tips before there is a take, and the preview
 * screen's pre-submit check once there is one. Both strings are production's, reused rather than
 * rewritten.
 */
export const RecordingTips: React.FC<Props> = ({ isReviewing }) => (
	<div
		className="bg-fill-weaker dark:bg-background-raised flex flex-col gap-3 rounded-lg p-4"
		data-testid="consolidated-tips"
	>
		{isReviewing ? (
			<Text as="p" variant="body" size="small" className="text-typography-strong">
				<TranslateHtml value="corgi.petition_actions.supporter_voice_video.submit.final_touches" />
			</Text>
		) : (
			<>
				<Text as="p" variant="body" size="small" className="text-typography-strong">
					<TranslateHtml value="corgi.petition_actions.supporter_voice_video.record.call_to_action_short" />
				</Text>
				<Text as="p" variant="body" size="small" className="text-typography-strong">
					<TranslateHtml value="corgi.petition_actions.supporter_voice_video.record.call_to_action_personal" />
				</Text>
				<Text as="p" variant="body" size="small" className="text-typography-strong">
					<TranslateHtml value="corgi.petition_actions.supporter_voice_video.record.call_to_action_show_up" />
				</Text>
			</>
		)}
	</div>
);
